import { Component, OnInit } from '@angular/core';
import { BasePaysheetService } from 'src/app/services/base-paysheet.service';
import { NgbModal, NgbDateAdapter, NgbDateNativeAdapter } from '@ng-bootstrap/ng-bootstrap';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { AuthService } from 'src/app/services/auth.service';
import { BasePaysheet } from 'src/app/models/base-paysheet';
import { DriverService } from 'src/app/services/driver.service';
import { ExpenseService } from 'src/app/services/expense.service';
import { Driver } from 'src/app/models/driver';
import { ExpenseType } from 'src/app/models/expense-type';
import { NativeDateAdapter } from 'src/app/adapters/native-date-adapter';
import { ToastrManager } from 'ng6-toastr-notifications';

@Component({
  selector: 'app-paysheet-base',
  templateUrl: './paysheet-base.component.html',
  styleUrls: ['./paysheet-base.component.css'],
  providers: [{provide: NgbDateAdapter, useClass: NgbDateNativeAdapter}]
})
export class PaysheetBaseComponent implements OnInit {
  public paysheets:BasePaysheet[] = [];
  public drivers:Driver[] = [];
  public expenses:ExpenseType[] = [];
  public loading = false;
  public paysheet:BasePaysheet = new BasePaysheet();
  public expand:boolean = false;

  public actEditPay:boolean = true;
  public actAddPay:boolean = true;
  public actDeletePay:boolean = true;

  public date1 = new Date();
  public date2 = new Date();

  constructor(private payServ:BasePaysheetService, private modalService: NgbModal, private utl:UtilitiesService, private authService:AuthService, private driverServ:DriverService, private expenseServ:ExpenseService, private toastr: ToastrManager) {
    this.date1.setDate(this.date1.getDate() - 6);
  }

  ngOnInit() {
    this.actEditPay = this.authService.can("update-paysheet");
    this.actDeletePay = this.authService.can("destroy-paysheet");
    this.actAddPay = this.authService.can("store-paysheet");

    this.search();

    this.driverServ.getDrivers(true).then(drivers => this.drivers = drivers);
    this.expenseServ.getExpenseTypes().then(types => this.expenses = types.filter(x => x.id == 13 || x.id == 14 || x.id == 15 || x.id == 16));
  }

  search() {
    this.loading = true;
    this.payServ.getBasePaysheets(this.date1, this.date2)
      .then(resp => {
        this.paysheets = resp;
        this.loading = false;
      });
  }

  storePaysheet(event) {
    event.preventDefault();

    if (!this.paysheet.pay) {
      this.toastr.infoToastr('El pago es requerido');
      return;
    }

    this.loading = true;
    this.payServ.postBasePaysheet(this.paysheet).then(resp => {
      this.toastr.successToastr('Creado Correctamente');
      this.search();
    });
  }

  updatePaysheet(event) {
    event.preventDefault();

    if (!this.paysheet.pay) {
      this.toastr.infoToastr('El pago es requerido');
      return;
    }

    this.loading = true;
    this.payServ.putBasePaysheet(this.paysheet).then(resp => {
      this.toastr.successToastr('Actualizado Correctly!');
      this.search();
    });
  }

  deletePaysheet() {
    this.loading = true;
    this.payServ.deleteBasePaysheet(this.paysheet).then(resp => {
      this.toastr.successToastr('Eliminado Correctly!');
      this.search();
    });
  }

  select(modal?, paysheet:BasePaysheet = new BasePaysheet()) {
    if(paysheet) {
      this.paysheet = paysheet;
    }

    if(modal) {
      this.modalService.open(modal, { size: 'lg' });
    }
  }

}
